"use strict";

exports.__esModule = true;
exports.default = void 0;

var _propTypes = require("prop-types");

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _vars = _interopRequireDefault(require("../../../constants/vars"));

var _colors = _interopRequireDefault(require("../../../constants/colors"));

var _breakpoints = _interopRequireDefault(require("../../../constants/breakpoints"));

var _InputFactory = _interopRequireWildcard(require("../InputFactory"));

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; if (obj != null) { var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _templateObject() {
  var data = _taggedTemplateLiteralLoose(["\n\twidth: ", ";\n\tfont-family: ", ";\n\tfont-size: ", ";\n\tpadding: ", ";\n\theight: ", ";\n\tmargin: 0.5rem 0;\n\tborder-radius: ", ";\n\tborder: ", " solid\n\t\t", ";\n\tbackground-color: ", ";\n\toutline: none;\n\tline-height: normal;\n\tdisplay: inline-block;\n\n\t@media (min-width: ", ") {\n\t\twidth: ", ";\n\t}\n\n\t&:focus {\n\t\tborder-color: ", " !important;\n\t\tbox-shadow: ", ";\n\t}\n\n\t&:disabled {\n\t\tcolor: ", ";\n\t\t-webkit-text-fill-color: ", ";\n\t\tborder-color: ", " !important;\n\t\tbackground-color: ", ";\n\t}\n\n\t&::placeholder {\n\t\tfont-family: ", ";\n\t\tcolor: ", ";\n\t}\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

function _taggedTemplateLiteralLoose(strings, raw) { if (!raw) { raw = strings.slice(0); } strings.raw = raw; return strings; }

var UnadornedBox = (0, _styledComponents.default)(_InputFactory.default)(_templateObject(), function (props) {
  return (0, _InputFactory.baseWidth)(props);
}, function (props) {
  return props.size === 'small' ? _vars.default.fontStackNormal : _vars.default.fontStackBold;
}, function (props) {
  return props.size === 'small' ? '90%' : '100%';
}, function (props) {
  return props.size === 'regular' ? '0 10px' : '0 8px';
}, function (props) {
  return props.size === 'regular' ? '2.75rem' : '2rem';
}, _vars.default.borderRadius, _vars.default.borderWidth, function (props) {
  return props.error ? _colors.default.error : _colors.default.borderColor;
}, _colors.default.white, _breakpoints.default.tablet, function (props) {
  return (0, _InputFactory.largerDevicesWidth)(props);
}, _colors.default.borderFocus, _vars.default.boxShadow, _colors.default.disabled, _colors.default.disabled, _colors.default.disabledOutline, _colors.default.disabledBackground, _vars.default.fontStackNormal, _colors.default.placeholder);
UnadornedBox.displayName = 'StyledInput';
UnadornedBox.propTypes = {
  size: (0, _propTypes.oneOf)(['small', 'regular']),
  error: (0, _propTypes.oneOfType)([_propTypes.bool, _propTypes.string]),
  fullWidth: _propTypes.bool,
  responsive: _propTypes.bool,
  mask: (0, _propTypes.oneOfType)([_propTypes.array, _propTypes.func, _propTypes.bool, (0, _propTypes.shape)({
    mask: (0, _propTypes.oneOfType)([_propTypes.array, _propTypes.func]),
    pipe: _propTypes.func
  })])
};
UnadornedBox.defaultProps = {
  size: 'regular',
  error: false,
  fullWidth: false,
  responsive: true,
  mask: undefined
};
var _default = UnadornedBox;
exports.default = _default;